import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebaseConfig';
import SubirHistoria from './SubirHistoria';
import SEO from './SEO';

function SubirHistoriaPage() {
  const [user] = useAuthState(auth);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <SEO title="Subir Historia | VipEncuentros" noindex={true} />
      <h1 className="text-2xl font-bold mb-4">Subir historia</h1>
      <SubirHistoria userId={user?.uid} />
    </div>
  );
}

export default SubirHistoriaPage;


